import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';
import ProductCard from '../components/ProductCard';

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWishlist = () => {
    api.get('auth/wishlist/')
      .then(res => setItems(res.data.results || res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchWishlist(); }, []);

  const handleRemove = (productId) => {
    setItems(prev => prev.filter(i => i.product_detail?.id !== productId));
  };

  if (loading) return <p style={{ textAlign: 'center', padding: 60, color: '#999' }}>Loading...</p>;

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 20px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 300, letterSpacing: 1, marginBottom: 32 }}>My Wishlist</h2>
      {items.length === 0 ? (
        <div className="empty-state">
          <h2>Your wishlist is empty</h2>
          <p>Save items you love for later.</p>
          <Link to="/shop" className="btn btn-primary">Browse Collection</Link>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24 }}>
          {items.map(item => (
            <ProductCard key={item.id} product={item.product_detail} onRemoveWishlist={handleRemove} />
          ))}
        </div>
      )}
    </div>
  );
}
